export const normalizeBrandValue = value => String(value || '').trim().toLowerCase();

export const getAvailableBrandValues = listings => {
  const unique = new Set();

  (Array.isArray(listings) ? listings : []).forEach(listing => {
    const brand = normalizeBrandValue(listing?.attributes?.publicData?.brand);
    if (brand) {
      unique.add(brand);
    }
  });

  return Array.from(unique);
};

export const filterListingsByBrand = (listings, brandFilter) => {
  if (!brandFilter) {
    return Array.isArray(listings) ? listings : [];
  }

  const selected = String(brandFilter)
    .split(',')
    .map(normalizeBrandValue)
    .filter(Boolean);

  return (Array.isArray(listings) ? listings : []).filter(listing => {
    const listingBrand = normalizeBrandValue(listing?.attributes?.publicData?.brand);
    return selected.includes(listingBrand);
  });
};
